<h1 mat-dialog-title>{{data.title ?? "Confirm"}}</h1>
<div mat-dialog-content>
  <p>{{data.content}}</p>
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="false">{{data.cancelText ?? "Cancel"}}</button>
  <button mat-button [mat-dialog-close]="true" [color]="(data.isDestructive ?? false ? 'warn' : null)">{{data.continueText ?? "Continue"}}</button>
</div>
